import { Filter } from '../../Enum/Filters';
import { FilterState } from '../../Store/Filter/state';
import { RootState } from '../../Store';

import { useSelector } from 'react-redux';
import useFilterIsActual from './UseFilterIsActual';

const useCanFilterBeSubmitted = (filters: Filter[], allowEmptyArray = false): boolean => {
    const { filterValues } = useSelector<RootState, FilterState>(state => state.filter);
    const filterIsActual = useFilterIsActual(filters);

    if (filterIsActual) {
        return false;
    }

    if (!allowEmptyArray) {
        return filters.every(filter => {
            return (
                !Array.isArray(filterValues[filter]) ||
                (Array.isArray(filterValues[filter]) && (filterValues[filter] as string[] | number[]).length > 0)
            );
        });
    }

    return true;
};

export default useCanFilterBeSubmitted;
